var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H33",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24H33",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H33",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.25C20.7426 20.25 21.75 19.2426 21.75 18C21.75 16.7574 20.7426 15.75 19.5 15.75C18.2574 15.75 17.25 16.7574 17.25 18C17.25 19.2426 18.2574 20.25 19.5 20.25Z",
    fill: "#1B2559",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26.25C28.2426 26.25 29.25 25.2426 29.25 24C29.25 22.7574 28.2426 21.75 27 21.75C25.7574 21.75 24.75 22.7574 24.75 24C24.75 25.2426 25.7574 26.25 27 26.25Z",
    fill: "#1B2559",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32.25C22.2426 32.25 23.25 31.2426 23.25 30C23.25 28.7574 22.2426 27.75 21 27.75C19.7574 27.75 18.75 28.7574 18.75 30C18.75 31.2426 19.7574 32.25 21 32.25Z",
    fill: "#1B2559",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.726975c72edfb28d066d1c7b985d621f.svg";
export { ForwardRef as ReactComponent };